import React from 'react';

interface ChoiceCardProps {
  /** Radio group name; cards sharing a name are one choice. */
  name: string;
  value: string;
  checked: boolean;
  onSelect: () => void;
  title: string;
  description?: string;
}

/** A selectable onboarding option: bordered card with a radio, title and description. */
export const ChoiceCard: React.FC<ChoiceCardProps> = ({
  name,
  value,
  checked,
  onSelect,
  title,
  description,
}) => (
  <label
    className={`block h-full border-2 rounded-lg p-3 cursor-pointer transition-all ${
      checked
        ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20'
        : 'border-gray-200 hover:border-gray-300 dark:border-white/15 dark:hover:border-white/25'
    }`}
  >
    <div className="flex items-start gap-3">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onSelect}
        className="w-4 h-4 mt-1"
      />
      <div className="flex-1">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</p>
        {description && (
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{description}</p>
        )}
      </div>
    </div>
  </label>
);
